import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'src/store/index';

export type State = {
  loading: boolean;
};

export const adapter = createEntityAdapter<Model.PagerField>({
  selectId: (model) => model.id,
});

const { reducer, actions } = createSlice({
  name: 'pager_field',
  initialState: adapter.getInitialState<State>({ loading: false }),
  reducers: {
    updateEntities(state, action: PayloadAction<Model.PagerField[]>) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.PagerField>) {
      adapter.upsertOne(state, action);
    },
    removeEntity(state, action: PayloadAction<Model.PagerField>) {
      adapter.removeOne(state, action.payload.id);
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    addChild(state, action: PayloadAction<Model.PagerField>) {
      const child = action.payload;
      const parent = state.entities[child.parent_id!]!;

      adapter.upsertOne(state, {
        ...parent,
        children: parent.children.concat(child),
      });
    },
    removeChild(state, action: PayloadAction<Model.PagerField>) {
      const child = action.payload;
      const parent = state.entities[child.parent_id!]!;

      adapter.upsertOne(state, {
        ...parent,
        children: parent.children.filter((c) => c.id !== child.id),
      });
    },
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.pager_fields,
);

export const selectPagerFieldsByClassId = createSelector(
  selector.selectAll,
  (state: RootState, class_id?: string) => class_id,
  (pager_fields, class_id) => {
    return pager_fields.filter(
      (p) => p.class_id === class_id && p.parent_id === null,
    );
  },
);

export { reducer };
export default actions;
